module.exports = __webpack_public_path__ + "img/partnership_logo_othm.e271e545.jpg";